export default __webpack_public_path__ + "static/media/arrowLeftLavander.03165c66.svg";